// src/index.ts
import { extendBaseTheme } from "@stepstone-genesis/dresscode-base";
import { careerstructure as baseCareerstructureTheme } from "@stepstone-genesis/design-tokens";
var careerstructure = extendBaseTheme(
  "careerstructure",
  baseCareerstructureTheme
);
export {
  careerstructure
};
